import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-h6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_modal_forms = _resolveComponent("modal-forms")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_card_section, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_q_avatar, {
            color: "black",
            size: "xs"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.t('form.addActivity')), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_q_card_section, { class: "q-pa-none" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navActivities, (item, activityIndex) => {
              return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                key: activityIndex,
                clickable: "",
                onClick: ($event: any) => (item.type !== 'store' ? (_ctx.modals[activityIndex] = !_ctx.modals[activityIndex]) : '')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_avatar, {
                        size: "sm",
                        color: item.color,
                        "text-color": "white",
                        icon: item.icon
                      }, null, 8, ["color", "icon"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.activityLabel(item.type)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_dialog, {
                    modelValue: _ctx.modals[activityIndex],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.modals[activityIndex]) = $event)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_modal_forms, {
                        "insert-data": _ctx.insertData,
                        "modal-type": item,
                        onCloseModal: ($event: any) => (_ctx.modals[activityIndex] = false)
                      }, null, 8, ["insert-data", "modal-type", "onCloseModal"])
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_ripple]
              ])
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_card_actions, {
      align: "right",
      class: "text-primary"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_q_btn, {
          flat: "",
          label: _ctx.t('form.close')
        }, null, 8, ["label"]), [
          [_directive_close_popup]
        ])
      ]),
      _: 1
    })
  ], 64))
}